import React, { useState, useEffect, useContext } from 'react';
import ReactDOM from 'react-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import GenericDialogBox from '../../components/GenericDialogBox';
import InfoBox from '../../components/InfoBox';
import DataService from "../../services/data.service";
import { useTranslation } from "react-i18next";
import PermissionContext from '../../contexts/PermissionContext';


const validationSchema = yup.object().shape({
	id: yup
		.number(),
	path: yup
		.string('Enter the path')
		.required('Path is required')
		.min(4, 'Path should be of minimum 4 characters length'),
	can_list: yup
		.boolean(),
	can_get: yup
		.boolean(),
	can_post: yup
		.boolean(),
	can_patch: yup
		.boolean(),
	can_delete: yup
		.boolean(),
	user_id: yup
		.string('Enter user name')
		.required('User required')
});


const useStyles = makeStyles((theme) => ({
	paper: {
		marginTop: theme.spacing(18),
		maxWidth: 800,
		margin: 'auto',
		overflow: 'hidden',
		backgroundColor: 'white'
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {

		margin: theme.spacing(3, 2, 2),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
}));



const userEndpoint = `user`
const endpoint = `permission`


const UserPermissionForm = React.forwardRef((props, ref) => {
	const { t } = useTranslation();

	const { idToUpdate, permission } = props;

	const {userHasPermission} = useContext(PermissionContext)
  
	// console.log("UHP",userHasPermission)
	
	let hasPerm = userHasPermission(permission, 'can_list')
	let hasAddPerm = userHasPermission(permission, 'can_post')
	let hasEditPerm = userHasPermission(permission, 'can_patch')
	let hasGetPerm = userHasPermission(permission, 'can_get')
	let hasDeletePerm = userHasPermission(permission, 'can_delete')
	// for detail form    
	let hasDeleteDetailPerm = userHasPermission(`${permission}-detail`, 'can_delete')


	// Getting User data only once at the beggining
	const [userData, setUserData] = useState([]);
	useEffect(() => {

		retrieveUserData()
	}, []); // Those ARE connectec

	const retrieveUserData = () => {
		DataService.getAll(userEndpoint)
			.then(response => {
				setUserData(response.data)
			})
			.catch(e => {
				openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)
			});
	}

	const [userValue, setUserValue] = React.useState(userData[0]);
	const [userInputValue, setUserInputValue] = React.useState('');

	const [pathValue, setPathValue] = React.useState("");

	const [canList, setCanList] = useState(false);
	const handleCanList = (event) => {
		setCanList(event.target.checked);
	};

	const [canGet, setCanGet] = useState(false);
	const handleCanGet = (event) => {
		setCanGet(event.target.checked);
	};

	const [canPost, setCanPost] = useState(false);
	const handleCanPost = (event) => {
		setCanPost(event.target.checked);
	};

	const [canPatch, setCanPatch] = useState(false);
	const handleCanPatch = (event) => {
		setCanPatch(event.target.checked);
	};

	const [canDelete, setCanDelete] = useState(false);
	const handleCanDelete = (event) => {
		setCanDelete(event.target.checked);
	};


	// INFO NOTIFICATION VARS
	const [infoOpen, setInfoOpen] = useState(false);
	const [infoTitle, setInfoTitle] = useState('');
	const [infoBody, setInfoBody] = useState('');
	//***********************

	//Dialog Vars
	const [dialogOpen, setDialogOpen] = useState(false);
	const [dialogueTitle, setDialogueTitle] = useState('');
	const [dialogueBody, setDialogueBody] = useState('');
	//**********

	// DIALOG FUNCTIONS 
	const handleDialogOk = () => {
		setDialogOpen(false)
	};

	const handleDialogClose = () => {
		setDialogOpen(false)
	};

	const openDialogBox = (title, body) => {
		setDialogueTitle(title)
		setDialogueBody(body)
		setDialogOpen(true)
	};
	//*******************

	// Notification INFO functions
	const openNoticeBox = (title, body) => {
		setInfoTitle(title)
		setInfoBody(body)
		setInfoOpen(true)
	};

	const handleInfoClose = () => {
		setInfoOpen(false)
	};
	// *****************

	const emptyData = {
		'id': typeof idToUpdate === 'object' ? 0 : idToUpdate,
		'path': pathValue,
		'user_id': userInputValue,
		'can_list': canList,
		'can_get': canGet,
		'can_post': canPost,
		'can_patch': canPatch,
		'can_delete': canDelete
	}

	const [data, setData] = useState(emptyData);
	useEffect(() => {
		let id = typeof idToUpdate === 'object' ? 0 : idToUpdate
		getData(id)
	}, []);

	const getData = (id) => {
		DataService.get(id, endpoint)
			.then(response => {
				// console.log("data get", response.data)
				setData(response.data)
				setUserValue(response.data.user)
				setPathValue(response.data.path)
				setCanGet(response.data.can_get == 1 ? true : false)
				setCanList(response.data.can_list == 1 ? true : false)
				setCanPost(response.data.can_post == 1 ? true : false)
				setCanPatch(response.data.can_patch == 1 ? true : false)
				setCanDelete(response.data.can_delete == 1 ? true : false)
			})
			.catch(e => {
				if (e.response.status != '404') {
					openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)
					// setData(emptyData)
				} else {
					setData(emptyData)
				}

			});
	}

	const updateData = (values) => {
		values.user_id = userValue.id
		DataService.update(endpoint, values)
			.then(response => {
				openNoticeBox("Notice", t("record_updated_successfully", { "table": t("permission_table_title") }))
				setData(emptyData)
			})
			.catch(e => {
				openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)
			});
	}

	const addData = (values) => {
		values.user_id = userValue.id
		// console.log("values", values)
		DataService.create(endpoint, values)
			.then(response => {
				openNoticeBox("Notice", t("record_created_successfully", { "table": t("permission_table_title") }))
				setData(emptyData)
			})
			.catch(e => {
				openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)
			});
	}


	const handleReset = (event) => {

	}

	const submitForm = (event) => {
		event.preventDefault();
		if (typeof userValue === 'undefined') {
			openNoticeBox("Notice", t("fill_all_fields_msg", { "table": t("client_document_table_title") }))
			return false
		}
		let values = {
			'user_id': userValue.id,
			'path': pathValue,
			'can_list': canList ? 1 : 0,
			'can_get': canGet ? 1 : 0,
			'can_post': canPost ? 1 : 0,
			'can_patch': canPatch ? 1 : 0,
			'can_delete': canDelete ? 1 : 0

		}

		if (typeof idToUpdate === 'object') {
			addData(values)
		}
		
		if (idToUpdate > 0) {
			values.id = idToUpdate
			delete values.path
			// console.log(values)
			updateData(values)
		}
		// console.log("submit ", values, idToUpdate)

	}

	const classes = useStyles();
	return (
		<Paper className={classes.paper}>
			<CssBaseline />
			<GenericDialogBox
				opn={dialogOpen}
				handleDialogOk={handleDialogOk}
				handleDialogClose={handleDialogClose}
				title={dialogueTitle}
				body={dialogueBody} />
			<InfoBox
				opn={infoOpen}
				handleDialogClose={handleInfoClose}
				title={infoTitle}
				body={infoBody} />

			<form className={classes.form} onSubmit={submitForm} onReset={handleReset}>
				<Grid container spacing={1}>
					<Grid item xs={12}>
						<Autocomplete
							id="user_id"
							name="user_id"
							// value={value}
							options={userData}
							getOptionLabel={(option) => option.username ? option.username : "-"}
							onChange={(event, newValue) => {
								setUserValue(newValue);
							}}
							inputValue={userInputValue}
							onInputChange={(event, newInputValue) => {
								setUserInputValue(newInputValue);
							}}

							value={userValue ? userValue : ""}
							renderInput={(params) => <TextField {...params} label={t("permission_form_lbl_invoice_user_id")} variant="outlined" />}
							getOptionSelected={(option, value) => option.value === value.value}
						/>
					</Grid>
					<Grid item xs={12}>
						<TextField
							variant="outlined"
							margin="normal"
							fullWidth
							id="path"
							label={t("permission_form_lbl_path")}
							name="path"
							value={pathValue}
							onChange={event => setPathValue(event.target.value)}
						/>
					</Grid>
					<Grid item xs={6}>
						<FormControlLabel
							value={canList}
							checked={canList}
							control={<Checkbox color="primary" />}
							label={t("permission_form_lbl_invoice_can_list")}
							labelPlacement="end"
							onChange={handleCanList}
							name="can_list"
							id="can_list"
						// disabled={idToUpdate === 0 ? false: true}
						/>
					</Grid>
					<Grid item xs={6}>
						<FormControlLabel
							value={canGet}
							checked={canGet}
							control={<Checkbox color="primary" />}
							label={t("permission_form_lbl_invoice_can_get")}
							labelPlacement="end"
							onChange={handleCanGet}
							name="can_get"
							id="can_get"
						// disabled={idToUpdate === 0 ? false: true}
						/>
					</Grid>
					<Grid item xs={6}>
						<FormControlLabel
							value={canPost}
							checked={canPost}
							control={<Checkbox color="primary" />}
							label={t("permission_form_lbl_invoice_can_post")}
							labelPlacement="end"
							onChange={handleCanPost}
							name="can_post"
							id="can_post"
						// disabled={idToUpdate === 0 ? false: true}
						/>
					</Grid>
					<Grid item xs={6}>
						<FormControlLabel
							value={canPatch}
							checked={canPatch}
							control={<Checkbox color="primary" />}
							label={t("permission_form_lbl_invoice_can_patch")}
							labelPlacement="end"
							onChange={handleCanPatch}
							name="can_patch"
							id="can_patch"
						// disabled={idToUpdate === 0 ? false: true}
						/>
					</Grid>
					<Grid item xs={6}>
						<FormControlLabel
							value={canDelete}
							checked={canDelete}
							control={<Checkbox color="primary" />}
							label={t("permission_form_lbl_invoice_can_delete")}
							labelPlacement="end"
							onChange={handleCanDelete}
							name="can_delete"
							id="can_delete"
						// disabled={idToUpdate === 0 ? false: true}
						/>
					</Grid>
					<Grid item xs={6}>

					</Grid>
					<Grid item xs={12}>
						<Button
							type="submit"
							fullWidth
							variant="contained"
							color="primary"
							className={classes.submit}
							disabled = {typeof idToUpdate === 'object' && hasAddPerm ? false : hasEditPerm ? false : true}
						>
							{typeof idToUpdate === 'object' ? t("save_form_button") : t("update_form_button")}
						</Button>
					</Grid>

				</Grid>
			</form>

			<Box mt={8}>

			</Box>
		</Paper>
	)
})

export default UserPermissionForm;
